/** CSS variables for AppToast — light/dark aware */
export function getAppToastCssVars(isDark) {
  const border = isDark ? 'rgba(148, 163, 184, 0.22)' : 'rgba(15, 23, 42, 0.12)';
  const text = isDark ? '#e5e7eb' : '#0f172a';

  return {
    '--app-toast-bg': isDark ? 'rgba(2, 6, 23, 0.86)' : 'rgba(255, 255, 255, 0.92)',
    '--app-toast-text': text,
    '--app-toast-border': border,
    '--app-toast-btn-bg': isDark ? 'rgba(226, 232, 240, 0.14)' : 'rgba(255, 255, 255, 0.95)',
    '--app-toast-btn-bg-hover': isDark ? 'rgba(226, 232, 240, 0.22)' : '#ffffff',
    '--app-toast-btn-text': isDark ? '#f8fafc' : '#0f172a',
  };
}

export const APP_TOAST_AUTO_HIDE_MS = 5000;
